export default {
    title: 'Audit',
    subtitle: 'Export activity log',

    columns: {
        createdAt: 'Date',
        user: 'User',
        email: 'Email',
        entity: 'Entity',
        format: 'Format',
        status: 'Status',
        records: 'Records',
        size: 'Size',
    },

    filters: {
        user: 'User',
        entity: 'Entity',
        format: 'Format',
        status: 'Status',
        date: 'Date',
    },

    status: {
        success: 'Success',
        failed: 'Failed',
        partial: 'Partial',
    },

    stats: {
        title: 'Last 30 days',
        totalExports: 'downloads',
        distinctUsers: 'users',
        topUser: 'Top user',
    },
}
